<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        *ngIf="employee"
        title="payroll.vacation-ytds.makeAdjustment"
        [subtitle]="{
            key: 'payroll.vacation-ytds.adjustmentFor',
            params: { fullName: employee?.fullName },
        }"
        [back]="true"
    ></app-header>
    <div class="app-grid margin-top-3">
        <ui-card class="columns-9">
            <ui-banner class="margin-bottom-3" variant="info">
                {{ 'payroll.vacation-ytds.adjustmentNote' | translate }}
            </ui-banner>
            <form #form="ngForm" autocomplete="off">
                <div class="app-grid">
                    <mat-form-field class="columns-4 small-columns-11">
                        <mat-label>{{ 'payroll.vacation-ytds.adjustmentAmount' | translate }}</mat-label>
                        <span matPrefix>$</span>
                        <input
                            type="text"
                            min="0.01"
                            matInput
                            type="string"
                            placeholder="Enter amount"
                            name="adjustmentAmount"
                            required
                            #adjustmentAmount="ngModel"
                            [(ngModel)]="adjustmentAmountInputted"
                            (change)="submitAndValidate()"
                        />
                        <mat-error *ngIf="adjustmentAmount.invalid">
                            {{ adjustmentAmount.errors | formErrors }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="app-grid">
                    <mat-label class="padding-bottom-1">{{ 'payroll.vacation-ytds.adjustment' | translate }}</mat-label>
                    <mat-radio-group
                        class="vertical"
                        required
                        name="addOrSubtractAdjustment"
                        [(ngModel)]="addOrSubtractAdjustmentCalculation"
                        #addOrSubtractAdjustment="ngModel"
                    >
                        <mat-radio-button [value]="'add'">{{
                            'payroll.vacation-ytds.add' | translate
                        }}</mat-radio-button>

                        <mat-radio-button [value]="'subtract'">{{
                            'payroll.vacation-ytds.subtract' | translate
                        }}</mat-radio-button>
                    </mat-radio-group>

                    <mat-error *ngIf="addOrSubtractAdjustment.invalid">{{
                        addOrSubtractAdjustment.errors | formErrors
                    }}</mat-error>
                </div>
                <div class="app-grid margin-top-3">
                    <div class="columns-12 flex align-items-center justify-start">
                        <mat-form-field>
                            <mat-label>{{ 'payroll.vacation-ytds.calculatedBalance' | translate }}</mat-label>
                            <span matPrefix>$</span>
                            <input
                                matInput
                                type="text"
                                name="calculatedYtdBalance"
                                readonly
                                [(ngModel)]="calculatedYtdBalanceAmount"
                            />
                        </mat-form-field>
                        <ui-button
                            [disabled]="!adjustmentAmountInputted"
                            [type]="'outline'"
                            class="columns-4 margin-left-2"
                            (click)="onCalculateYTDBalance()"
                            >{{ 'payroll.vacation-ytds.calculate' | translate }}
                        </ui-button>
                    </div>
                </div>
                <div class="app-grid">
                    <mat-form-field class="columns-12">
                        <mat-label>{{ 'payroll.vacation-ytds.addNote' | translate }}</mat-label>
                        <textarea
                            placeholder="{{ 'payroll.vacation-ytds.addNotePlaceholder' | translate }}"
                            [(ngModel)]="adjustmentMessage"
                            maxlength="255"
                            name="adjustmentNote"
                            #adjustmentNote="ngModel"
                            matInput
                        ></textarea>
                        <mat-error *ngIf="adjustmentNote.invalid">{{ adjustmentNote.errors | formErrors }}</mat-error>
                    </mat-form-field>
                </div>
            </form>
        </ui-card>
        <ui-card style="height: 50%" class="columns-3">
            <h2>{{ 'payroll.vacation-ytds.summary' | translate }}</h2>
            <div class="margin-top-3">
                <div class="subtitle">{{ 'payroll.vacation-ytds.afterAdjustment' | translate }}</div>
                <p
                    class="summary-amount"
                    *ngIf="calculatedYtdBalanceAmount && adjustmentHasBeenCalculated; else displayDash"
                >
                    ${{ calculatedYtdBalanceAmount }}
                </p>
            </div>
            <div class="margin-top-3">
                <div class="subtitle">{{ 'payroll.vacation-ytds.balanceBefore' | translate }}</div>
                <p class="summary-amount" *ngIf="latestEmployeeVacationYtdAdjustment; else displayDash">
                    {{ latestEmployeeVacationYtdAdjustment | currency }}
                </p>
            </div>
        </ui-card>
    </div>
    <div class="app-grid margin-top-1">
        <div class="flex align-items-center justify-end columns-9">
            <ui-button (click)="onRedirect()">{{ 'cancel' | translate }}</ui-button>
            <ui-button (click)="onSave()" type="primary">{{ 'save' | translate }}</ui-button>
        </div>
    </div>
</div>

<ng-template #displayDash>
    <p>-</p>
</ng-template>
